import './Line.css';

const Line = () => (
  <div className="Nav-Separator" />
);

export default Line;
